import React, { useState, useEffect } from 'react';
import api from '../../api/api';
import ClientLayout from '../../components/ClientLayout';
import { useNavigate } from 'react-router-dom';

// --- CONSTANTES ---
const COLORS = {
    green: '#2E5B2E',
    pink: '#C19A6B',
    cream: '#F9F9F5',
    dark: '#333333',
    white: '#FFFFFF',
    red: '#DC2626',
    gray: '#E5E7EB',
    gold: '#D97706',
    blue: '#2563EB'
};

// Catálogo para el dropdown de "Agregar Nuevo"
const CATALOGO_PRODUCTOS = [
    { key: 'CAFE_AMERICANO', label: 'Café Americano' },
    { key: 'ESPECIALIDAD_CHIAPAS', label: 'Especialidad Chiapas' },
    { key: 'ESPECIALIDAD_GUERRERO', label: 'Especialidad Guerrero' },
    { key: 'DESCAFEINADO', label: 'Descafeinado' },
    { key: 'CAFE_DE_OLLA', label: 'Café de Olla' },
    { key: 'CAFE_EJECUTIVO', label: 'Mezcla Ejecutiva' }
];

function MisSucursales() {
    const [sucursales, setSucursales] = useState([]);
    const [loading, setLoading] = useState(true);
    const [showForm, setShowForm] = useState(false);
    const [expandedBranch, setExpandedBranch] = useState(null);

    // --- ESTADO MODAL STOCK ---
    const [showStockModal, setShowStockModal] = useState(false);
    const [stockForm, setStockForm] = useState({
        sucursalId: '',
        producto: '',
        nombreProducto: '',
        cantidad: '',
        tipo: 'GRANO',
        accion: 'SUMAR', // SUMAR o RESTAR
        isNew: false     // Bandera para saber si es producto nuevo
    });
    const [savingStock, setSavingStock] = useState(false);

    // Formulario Nueva Sucursal
    const [formData, setFormData] = useState({
        nombre: '', direccion: '', ciudad: 'Querétaro', telefono: ''
    });

    const navigate = useNavigate();

    // Cargar datos
    const fetchSucursales = async () => {
        try {
            const token = localStorage.getItem('token');
            const { data } = await api.get('/sucursales/me', {
                headers: { Authorization: `Bearer ${token}` }
            });
            setSucursales(data);
        } catch (error) { console.error(error); } finally { setLoading(false); }
    };

    useEffect(() => { fetchSucursales(); }, []);

    // --- MODAL: AGREGAR NUEVO PRODUCTO ---
    const openAddProductModal = (sucursalId) => {
        setStockForm({
            sucursalId,
            producto: CATALOGO_PRODUCTOS[0].key, // Selecciona el primero por defecto
            nombreProducto: '',
            cantidad: '',
            tipo: 'GRANO',
            accion: 'SUMAR', // Al crear, siempre sumamos
            isNew: true      // Habilita el selector de productos
        });
        setShowStockModal(true);
    };

    // --- MODAL: AJUSTAR EXISTENTE ---
    const openAdjustModal = (sucursalId, productoKey) => {
        setStockForm({
            sucursalId,
            producto: productoKey,
            nombreProducto: productoKey.replace(/_/g, ' '),
            cantidad: '',
            tipo: 'MOLIDO',
            accion: 'RESTAR', // Por defecto consumo
            isNew: false      // Producto fijo
        });
        setShowStockModal(true);
    };

    // Guardar Stock
    const handleStockUpdate = async (e) => {
        e.preventDefault();
        setSavingStock(true);
        const token = localStorage.getItem('token');

        try {
            let cantidadFinal = Number(stockForm.cantidad);
            // Si es RESTA, invertimos signo
            if (stockForm.accion === 'RESTAR') {
                cantidadFinal = cantidadFinal * -1;
            }

            await api.post('/sucursales/stock/add', {
                sucursalId: stockForm.sucursalId,
                producto: stockForm.producto,
                cantidad: cantidadFinal,
                tipo: stockForm.tipo
            }, { headers: { Authorization: `Bearer ${token}` } });

            alert("✅ Inventario actualizado");
            setShowStockModal(false);
            fetchSucursales();

        } catch (error) {
            console.error(error);
            alert("Error al actualizar.");
        } finally {
            setSavingStock(false);
        }
    };

    // Crear Sucursal
    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const token = localStorage.getItem('token');
            await api.post('/sucursales', formData, { headers: { Authorization: `Bearer ${token}` } });
            alert("✅ Sucursal creada");
            setShowForm(false);
            setFormData({ nombre: '', direccion: '', ciudad: 'Querétaro', telefono: '' });
            fetchSucursales();
        } catch (error) { alert("Error al crear sucursal."); }
    };

    const getStockTotal = (inventarios) => {
        if (!inventarios || inventarios.length === 0) return 0;
        return inventarios.reduce((acc, item) => acc + (Number(item.cantidadGrano)||0) + (Number(item.cantidadMolido)||0), 0);
    };

    const toggleInventario = (id) => setExpandedBranch(expandedBranch === id ? null : id);

    // Estilos
    const cardStyle = { background: COLORS.white, borderRadius: 12, padding: 20, boxShadow: '0 4px 12px rgba(0,0,0,0.08)', borderTop: `5px solid ${COLORS.green}`, flex: '1 1 350px', display: 'flex', flexDirection: 'column', justifyContent: 'space-between' };
    const badgeStyle = { fontSize: 10, padding: '3px 8px', borderRadius: 4, fontWeight: 'bold', display:'flex', alignItems:'center', gap: 4 };
    const modalOverlay = { position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,0.6)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000 };

    return (
        <ClientLayout title="Gestión de Sucursales">
            <div style={{ maxWidth: 1200, margin: '0 auto' }}>
                
                {/* HEADER */}
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 30 }}>
                    <div>
                        <h2 style={{ color: COLORS.green, margin: 0 }}>Mis Puntos de Venta</h2>
                        <p style={{ color: COLORS.dark, margin: 0, fontSize: 14 }}>Administra tus tiendas.</p>
                    </div>
                    <button onClick={() => setShowForm(!showForm)} style={{ background: COLORS.pink, color: COLORS.white, border: 'none', padding: '12px 20px', borderRadius: 8, fontWeight: 'bold', cursor: 'pointer' }}>
                        {showForm ? 'Cancelar' : '+ Nueva Sucursal'}
                    </button>
                </div>

                {/* FORMULARIO NUEVA SUCURSAL */}
                {showForm && (
                    <div style={{ background: COLORS.cream, padding: 25, borderRadius: 12, marginBottom: 30, border: `1px solid ${COLORS.pink}` }}>
                        <h3 style={{ marginTop: 0 }}>📍 Registrar Nueva Tienda</h3>
                        <form onSubmit={handleSubmit} style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: 15 }}>
                            <input required placeholder="Nombre" style={inputStyle} value={formData.nombre} onChange={e => setFormData({...formData, nombre: e.target.value})} />
                            <input required placeholder="Dirección" style={inputStyle} value={formData.direccion} onChange={e => setFormData({...formData, direccion: e.target.value})} />
                            <input required placeholder="Ciudad" style={inputStyle} value={formData.ciudad} onChange={e => setFormData({...formData, ciudad: e.target.value})} />
                            <input placeholder="Teléfono" style={inputStyle} value={formData.telefono} onChange={e => setFormData({...formData, telefono: e.target.value})} />
                            <button type="submit" style={{ ...btnStyle, background: COLORS.green, gridColumn: '1 / -1' }}>Guardar Sucursal</button>
                        </form>
                    </div>
                )}

                {/* LISTA DE SUCURSALES */}
                {loading ? <p>Cargando...</p> : (
                    <div style={{ display: 'flex', flexWrap: 'wrap', gap: 20 }}>
                        {sucursales.map((sucursal) => {
                            const stockTotal = getStockTotal(sucursal.inventarios);
                            const isExpanded = expandedBranch === sucursal.id;

                            return (
                                <div key={sucursal.id} style={cardStyle}>
                                    <div>
                                        <div style={{display:'flex', justifyContent:'space-between'}}>
                                            <h3 style={{ margin: '0', color: COLORS.green }}>{sucursal.nombre}</h3>
                                            <span style={{ fontSize: 12, background: COLORS.cream, padding: '2px 8px', borderRadius: 10, border: '1px solid #ddd' }}>{sucursal.ciudad}</span>
                                        </div>
                                        <div style={{ fontSize: 13, color: COLORS.dark, marginTop: 5 }}>📍 {sucursal.direccion}</div>
                                    </div>

                                    {/* PANEL DE INVENTARIO */}
                                    <div style={{ background: COLORS.cream, padding: 15, borderRadius: 8, marginTop: 15, border: `1px solid ${COLORS.gray}` }}>
                                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                            <span style={{ fontWeight: 'bold', fontSize: 12 }}>Stock Total</span>
                                            <span style={{ fontWeight: 'bold', color: stockTotal < 5 ? COLORS.red : COLORS.green, fontSize: 16 }}>
                                                {stockTotal.toFixed(1)} Kg
                                            </span>
                                        </div>
                                        <div style={{ width: '100%', height: 6, background: '#ddd', borderRadius: 3, overflow: 'hidden', marginTop: 8 }}>
                                            <div style={{ width: `${Math.min(stockTotal, 50) * 2}%`, height: '100%', background: stockTotal < 5 ? COLORS.red : COLORS.green }}></div>
                                        </div>

                                        <div style={{ textAlign: 'center', marginTop: 12 }}>
                                            <button onClick={() => toggleInventario(sucursal.id)} style={{ fontSize: 12, background: 'transparent', border: 'none', color: COLORS.pink, cursor: 'pointer', fontWeight:'bold' }}>
                                                {isExpanded ? '▲ Ocultar Detalle' : '▼ Ver Inventario'}
                                            </button>
                                        </div>

                                        {/* DETALLE DESPLEGABLE */}
                                        {isExpanded && (
                                            <div style={{ marginTop: 15, borderTop: '1px solid #ddd', paddingTop: 10 }}>
                                                
                                                {/* BOTÓN AGREGAR PRODUCTO (NUEVO) */}
                                                <button 
                                                    onClick={() => openAddProductModal(sucursal.id)}
                                                    style={{ width: '100%', padding: 8, marginBottom: 10, background: COLORS.white, border: `1px dashed ${COLORS.green}`, color: COLORS.green, borderRadius: 6, cursor: 'pointer', fontWeight: 'bold', fontSize: 12 }}
                                                >
                                                    + Agregar Nuevo Café
                                                </button>

                                                {sucursal.inventarios && sucursal.inventarios.length > 0 ? (
                                                    <div style={{ display: 'grid', gridTemplateColumns: '1fr', gap: 10 }}>
                                                        {sucursal.inventarios.map(inv => {
                                                            const totalProd = Number(inv.cantidadGrano || 0) + Number(inv.cantidadMolido || 0);
                                                            return (
                                                                <div key={inv.id} style={{ background: 'white', padding: 10, borderRadius: 6, border: '1px solid #eee', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                                                    <div>
                                                                        <div style={{ fontSize: 11, color: '#666', fontWeight:'bold', textTransform:'uppercase' }}>{inv.producto.replace(/_/g, ' ')}</div>
                                                                        <div style={{ fontSize: 14, fontWeight:'bold', color: COLORS.dark }}>{totalProd.toFixed(1)} Kg</div>
                                                                        <div style={{ display: 'flex', gap: 4, marginTop: 2 }}>
                                                                            <span style={{ ...badgeStyle, background: '#F3F4F6', color: '#374151' }}>🫘 {Number(inv.cantidadGrano).toFixed(1)}</span>
                                                                            <span style={{ ...badgeStyle, background: '#FFF7ED', color: '#9A3412' }}>⏳ {Number(inv.cantidadMolido).toFixed(1)}</span>
                                                                        </div>
                                                                    </div>
                                                                    <button onClick={() => openAdjustModal(sucursal.id, inv.producto)} style={{ background: '#F3F4F6', border: `1px solid ${COLORS.gray}`, borderRadius: 6, padding: '5px 10px', cursor: 'pointer' }} title="Ajustar">⚙️</button>
                                                                </div>
                                                            );
                                                        })}
                                                    </div>
                                                ) : (
                                                    <p style={{ fontSize: 12, color: '#999', textAlign: 'center', fontStyle:'italic' }}>Inventario vacío.</p>
                                                )}
                                            </div>
                                        )}
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                )}

                {/* MODAL DE STOCK (Multifunción) */}
                {showStockModal && (
                    <div style={modalOverlay}>
                        <div style={{ background: 'white', padding: 25, borderRadius: 12, width: 350, boxShadow: '0 20px 25px -5px rgba(0,0,0,0.1)' }}>
                            <h3 style={{ marginTop: 0, color: COLORS.dark }}>
                                {stockForm.isNew ? '✨ Agregar Nuevo Producto' : 'Ajustar Inventario'}
                            </h3>
                            
                            <form onSubmit={handleStockUpdate}>
                                
                                {/* SELECTOR DE PRODUCTO (Solo si es nuevo) */}
                                {stockForm.isNew ? (
                                    <div style={{ marginBottom: 15 }}>
                                        <label style={{ fontSize: 12, fontWeight: 'bold', display: 'block', marginBottom: 5 }}>Selecciona el Café</label>
                                        <select 
                                            style={inputStyle} 
                                            value={stockForm.producto} 
                                            onChange={e => setStockForm({...stockForm, producto: e.target.value})}
                                        >
                                            {CATALOGO_PRODUCTOS.map(p => (
                                                <option key={p.key} value={p.key}>{p.label}</option>
                                            ))}
                                        </select>
                                    </div>
                                ) : (
                                    <p style={{ fontSize: 13, color: '#666', marginBottom: 20 }}>
                                        Producto: <b>{stockForm.nombreProducto}</b>
                                    </p>
                                )}

                                {/* ACCIÓN (Oculta si es nuevo, asumimos ingreso) */}
                                {!stockForm.isNew && (
                                    <div style={{ display: 'flex', gap: 10, marginBottom: 15 }}>
                                        <button type="button" onClick={() => setStockForm({...stockForm, accion: 'RESTAR'})} style={{ flex: 1, padding: 8, border: stockForm.accion === 'RESTAR' ? `2px solid ${COLORS.red}` : '1px solid #ddd', borderRadius: 6, background: stockForm.accion === 'RESTAR' ? '#FEF2F2' : 'white', cursor: 'pointer', fontWeight: 'bold', color: stockForm.accion === 'RESTAR' ? COLORS.red : '#666' }}>📉 Consumo</button>
                                        <button type="button" onClick={() => setStockForm({...stockForm, accion: 'SUMAR'})} style={{ flex: 1, padding: 8, border: stockForm.accion === 'SUMAR' ? `2px solid ${COLORS.green}` : '1px solid #ddd', borderRadius: 6, background: stockForm.accion === 'SUMAR' ? '#F0FDF4' : 'white', cursor: 'pointer', fontWeight: 'bold', color: stockForm.accion === 'SUMAR' ? COLORS.green : '#666' }}>📈 Ingreso</button>
                                    </div>
                                )}

                                {/* TIPO */}
                                <label style={{ fontSize: 12, fontWeight: 'bold', display: 'block', marginBottom: 5 }}>Presentación</label>
                                <select style={{ ...inputStyle, marginBottom: 15 }} value={stockForm.tipo} onChange={e => setStockForm({...stockForm, tipo: e.target.value})}>
                                    <option value="GRANO">🫘 Grano</option>
                                    <option value="MOLIDO">⏳ Molido</option>
                                </select>

                                {/* CANTIDAD */}
                                <label style={{ fontSize: 12, fontWeight: 'bold', display: 'block', marginBottom: 5 }}>Cantidad (Kg)</label>
                                <input type="number" step="1" min="0" autoFocus required placeholder="Ej: 1.0" style={{ ...inputStyle, marginBottom: 20, fontSize: 18 }} value={stockForm.cantidad} onChange={e => setStockForm({...stockForm, cantidad: e.target.value})} />

                                <div style={{ display: 'flex', gap: 10 }}>
                                    <button type="button" onClick={() => setShowStockModal(false)} style={{ flex: 1, padding: 10, borderRadius: 8, border: 'none', background: '#f0f0f0', cursor: 'pointer' }}>Cancelar</button>
                                    <button type="submit" disabled={savingStock} style={{ flex: 1, padding: 10, borderRadius: 8, border: 'none', background: COLORS.green, color: 'white', fontWeight: 'bold', cursor: 'pointer' }}>{savingStock ? 'Guardando...' : 'Confirmar'}</button>
                                </div>
                            </form>
                        </div>
                    </div>
                )}
            </div>
        </ClientLayout>
    );
}

const inputStyle = { padding: 12, borderRadius: 8, border: '1px solid #ccc', width: '100%' };
const btnStyle = { padding: 12, borderRadius: 8, border: 'none', color: 'white', fontWeight: 'bold', cursor: 'pointer' };

export default MisSucursales;